'use client';

export const dynamic = 'force-dynamic';

import { LanguageObject } from "@/components/Types";
import { NATIVE_LANGUAGES } from "@/lib/constants";
import { MOBILE_BREAKPOINT } from "@/lib/constants-ui";
import { LearningFeedPost } from "@/lib/types/feed";
import { Breadcrumbs, BreadcrumbItem } from "@heroui/react";
import { useEffect, useState } from "react";

export default function BreadcrumbsElement({nativeLanguage, post, t}: {nativeLanguage: string, post: Partial<LearningFeedPost>, t: any}) {
    const [isMobile, setIsMobile] = useState(true);

    useEffect(() => {
        setIsMobile((typeof window !== "undefined" && (window as any))?.innerWidth < MOBILE_BREAKPOINT);
    }, []);

    const nativeLanguageKey = (Object.keys(NATIVE_LANGUAGES).find((language) => NATIVE_LANGUAGES[language].code?.toLowerCase() == nativeLanguage.toLowerCase()) as any);;
    const nativeLanguageObject = NATIVE_LANGUAGES[nativeLanguageKey as keyof typeof NATIVE_LANGUAGES];    

    const learningFocus = post.learningFocus[0] || "";
    let learningFocusTitle = t.learningFocus[learningFocus] || learningFocus || "";
    let postTitle = post.title;

    const maxCategoryLength = isMobile ? 12 : 20;
    const maxTitleLength = isMobile ? 16 : 30;

    learningFocusTitle = learningFocusTitle.length > maxCategoryLength ? learningFocusTitle.substring(0, maxCategoryLength) + "..." : learningFocusTitle;
    postTitle = postTitle.length > maxTitleLength ? postTitle.substring(0, maxTitleLength) + "..." : postTitle;

    return (
        <div>
            <Breadcrumbs classNames={{
                list: "gap-y-2",
            }} size={isMobile ? "sm" : "md"} radius={isMobile ? "none" : "full"} variant={isMobile ? "light" : "bordered"} underline="active">
                    <BreadcrumbItem>{t.languages[post.language]}</BreadcrumbItem>
                    <BreadcrumbItem href={`/learn/${post.language}/${nativeLanguage}`}>{nativeLanguageObject?.emoji}</BreadcrumbItem>
                    <BreadcrumbItem href={`/focus/${post.language}/${nativeLanguage}/${learningFocus}`}>{learningFocusTitle}</BreadcrumbItem>
                    <BreadcrumbItem isCurrent={true} isLast={true}>{postTitle}</BreadcrumbItem>
            </Breadcrumbs>
        </div>
    );
}